export default __webpack_public_path__ + "media/images/react_icons/plus-ccba003f30ba03723ce06f2139202cef.svg";